import React, { useRef, useState, useEffect } from "react";
import { Dropdown, Image, Media, Form, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { saveBookmarkStart } from "../../store/actions/BookmarkAction";
import {
  fetchCommentsStart,
  saveCommentStart,
} from "../../store/actions/CommentsAction";
import { savePostLikeStart } from "../../store/actions/PostLikesAction";
import ImageLoader from "./ImageLoader";
import SendTipModal from "./SendTipModal";
import ReportModeModal from "./ReportModeModal";
import HomePostUser from "../Home/HomePostUser"
import PPVPaymentModal from "./PPVPaymentModal";
import ReactPlayer from "react-player/lazy";
import { createNotification } from "react-redux-notify/lib/modules/Notifications";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getSuccessNotificationMessage } from "../helper/NotificationMessage";
import {
  deletePostStart,
  saveReportPostStart,
  videoViewPostStart
} from "../../store/actions/PostAction";
import { saveBlockUserStart } from "../../store/actions/UserAction";
import VerifiedBadgeNoShadow from "../Handlers/VerifiedBadgeNoShadow";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { translate, t } from "react-multi-lang";
import api from "../../Environment";
import { useDispatch } from "react-redux";
import { trackAd } from "../../store/actions/AdActions";

const PostDisplayCard = (props) => {
  const { post } = props;
  let totalLikes = props.post.total_likes ? props.post.total_likes : 0;
  let total_view = props.post.total_views ? props.post.total_views : 0;
  const [playingAd, setPlayingAd] = useState(!!post?.ad);
  const adUrl = (post?.ad) ? api.serviceUrl() + "/" + post?.ad?.media_path : "";
  const mainUrl = api.serviceUrl() + "/" + props?.post?.postFiles[0]?.post_file;
  const dispatch = useDispatch();

  const videoRef = useRef(null);
  const [PPVPayment, setPPVPayment] = useState(false);
  const [sendTip, setSendTip] = useState(false);
  const [commentInputData, setCommentInputData] = useState({});
  const [isVisible, setIsVisible] = useState(true);
  const [reportMode, setReportMode] = useState(false);
  const [bookmarkStatus, setBookmarkStatus] = useState("");
  const [postDisplayStatus, setPostDisplayStatus] = useState(true);
  const [likeStatus, setLikeStatus] = useState("");
  const isLiked = likeStatus === "added" || (likeStatus === "" && post.is_user_liked == 1);
  const [likeCount, setLikeCount] = useState(totalLikes);
  const [totalViews, setTotalViews] = useState(total_view);
  const [modalStatus, setModalStatus] = useState(0);
  const [showAd, setShowAd] = useState(false);

  const [duration, setDuration] = useState(0);
  const [playedSeconds, setPlayedSeconds] = useState(0);
  const [skipCountdown, setSkipCountdown] = useState(5);

  const skipDelay = 10;      // show skip after 10 sec
  const countdownStart = 5;  // countdown seconds

  // Track ad playback progress
  const handleProgress = (state) => {
    setPlayedSeconds(state.playedSeconds);
  };

  // Reset timers when switching videos
  useEffect(() => {
    setPlayedSeconds(0);
    setDuration(0);
    setSkipCountdown(countdownStart);
  }, [playingAd]);

  // Skip countdown logic
  useEffect(() => {
    if (!playingAd) return;
    if (playedSeconds >= skipDelay && skipCountdown > 0) {
      const timer = setInterval(() => { setSkipCountdown((prev) => { if (prev <= 1) { clearInterval(timer); return 0; } return prev - 1; }); }, 1000); return () => clearInterval(timer);
    }
  }, [playedSeconds, playingAd]);

  const [localComments, setLocalComments] = useState(post.post_comments || []);

  useEffect(() => {
    if (post.post_comments) {
      setLocalComments(post.post_comments);
    }
  }, [post.post_comments]);

  useEffect(() => {
    // Show comments by default on mount
    setCommentInputData({ post_id: post.post_id });
    setIsVisible(true);
  }, [post.post_id]);

  useEffect(() => {
    const newComment = props.saveComment?.data;
    if (newComment && newComment.post_id == post.post_id) {
      const exists = localComments.some(
        (c) => c.post_comment_id == newComment.post_comment_id ||
          (c.comment === newComment.comment && c.user_unique_id === localStorage.getItem("user_unique_id"))
      );
      if (!exists) {
        const hydratedComment = {
          ...newComment,
          user_displayname: newComment.user_displayname || localStorage.getItem("user_displayname"),
          user_picture: newComment.user_picture || localStorage.getItem("user_picture"),
          user_unique_id: newComment.user_unique_id || localStorage.getItem("user_unique_id"),
          created: newComment.created || "Just now"
        };
        setLocalComments((prev) => [...prev, hydratedComment]);
      }
    }
  }, [props.saveComment?.data, post.post_id]);

  useEffect(() => {
    const deletedComment = props.delComment?.data;
    if (deletedComment && deletedComment.post_id === post.post_id) {
      setLocalComments((prev) =>
        prev.filter((c) => c.post_comment_id !== deletedComment.post_comment_id)
      );
    }
  }, [props.delComment?.data, post.post_id]);

  const toggleCommentSection = (event, post_id) => {
    event.preventDefault();
    if (isVisible && commentInputData.post_id === post.post_id) {
      setIsVisible(false);
    } else {
      setCommentInputData({ post_id: post_id });
      setIsVisible(true);
    }
  };

  const closeReportModeModal = () => {
    setReportMode(false);
  };

  const closeSendTipModal = () => {
    setSendTip(false);
  };
  const closePPVPaymentModal = () => {
    setPPVPayment(false);
  };

  const handleImagePreview = (event, status, paymentStatus) => {
    event.preventDefault();
    if (paymentStatus == 0) {
      setModalStatus(status);
    }
  };

  const handleCommentSubmit = (event) => {
    event.preventDefault();
    props.dispatch(saveCommentStart(commentInputData));
    setCommentInputData({ post_id: post.post_id, comment: "" });
  };

  const showCommentSection = (event, post_id) => {
    setCommentInputData({ post_id: post_id });
    setIsVisible(true);
    props.dispatch(fetchCommentsStart({ post_id: post_id }));
  };

  const handleLike = (event, status) => {
    event.preventDefault();
    setLikeStatus(status);
    props.dispatch(savePostLikeStart({ post_id: post.post_id }));
    if (status == "added") {
      let currentLikeCount = likeCount + 1;
      setLikeCount(currentLikeCount);
    } else {
      let currentLikeCount = likeCount - 1;
      setLikeCount(currentLikeCount);
    }
  };

  const handlePPVPayment = (event, status) => {
    event.preventDefault();
    if (status && status == 1) {
      setModalStatus(0);
      setPPVPayment(true);
    } else {
      setModalStatus(1);
      setPPVPayment(false);
    }
  };

  const handleBookmark = (event, post, status) => {
    event.preventDefault();
    setBookmarkStatus(status);
    props.dispatch(saveBookmarkStart({ post_id: post.post_id }));
  };

  const handleReportPost = (event, post) => {
    event.preventDefault();
    setPostDisplayStatus(false);
    props.dispatch(saveReportPostStart({ post_id: post.post_id }));
  };
  const handleBlockUser = (event, post) => {
    event.preventDefault();
    setPostDisplayStatus(false);
    props.dispatch(saveBlockUserStart({ user_id: post.user_id }));
  };

  const handleDeletePost = (event, post) => {
    event.preventDefault();
    setPostDisplayStatus(false);
    props.dispatch(deletePostStart({ post_id: post.post_id }));
  };

  const closeCommentSection = (event) => {
    setIsVisible(false);
  };

  const onCopy = (event) => {
    const notificationMessage = getSuccessNotificationMessage(
      "Link to the post was copied to clipboard!"
    );
    props.dispatch(createNotification(notificationMessage));
  };

  const saveViewCount = (post_id, host_id) => {

    let obj = {
      user_id: localStorage.getItem("userId"),
      post_id: post_id,
      host_id: host_id
    }
    // console.log(obj)
    if (obj.user_id != obj.host_id) {
      props.dispatch(videoViewPostStart(obj));
    }
  }

  const saveAdTrack = (ad_id, post_id, host_id) => {

    let obj = {
      user_id: localStorage.getItem("userId"),
      post_id: post_id,
      ad_id: ad_id,
      to_user_id: host_id
    };

    if (obj.user_id != obj.to_user_id) {
      dispatch(trackAd({
        ad_id: obj.ad_id,
        post_id: obj.post_id,
        to_user_id: obj.to_user_id,
      }));
    }

  }

  const format = (sec) => {
    if (!sec || sec < 0) return "0:00";
    const minutes = Math.floor(sec / 60);
    const seconds = Math.floor(sec % 60);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  const handleEnded = () => {

    const video = videoRef.current;

    if (playingAd) {
      // Switch to main video WITHOUT exiting fullscreen
      setPlayingAd(false);
      video.src = mainUrl;
      video.load();

      // autoplay main video (works because user already interacted)
      video.play();
      // when advertisement end that time ad track
      saveAdTrack(post?.ad?.id, post.post_id, post.user_id)
    }
  };

  return (
    <>
      {postDisplayStatus == true ? (
        <div className="post-list">
          <div className="post-header">
            <div className="alignleft">
              <Link className="title-container" to={`/${post.user_unique_id}`}>
                <ImageLoader
                  image={
                    post.user.picture
                      ? api.serviceUrl() + "/" + post.user.picture
                      : "/assets/images/upload-profile-img.svg"
                  }
                  className="user-image img-responsive"
                />

                <div className="user-name">
                  <span className="post-user-name">
                    <span className="user-name-post">
                      {post.user_displayname}
                    </span>
                    {"  "}
                    {post.is_verified_badge == 1 ? (
                      <VerifiedBadgeNoShadow />
                    ) : null}
                  </span>
                  <span className="post-user-">@{post.username}</span>
                </div>
              </Link>
            </div>
            <div className="alignright">
              <div className="post-header-right-side">
                <span className="post-time flex-content">
                  <span className="post-time">
                    {post.publish_time_formatted}
                  </span>
                  <Dropdown>
                    <Dropdown.Toggle
                      className="btn btn-default dropdown-toggle"
                      type="button"
                      id="dropdown-basic"
                    >
                      <Image
                        src={
                          window.location.origin +
                          "/assets/images/icons/vertical-dots.svg"
                        }
                        className="svg-clone vertical-dots"
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className={props?.comeFrom == "home" ? "dropdown-menu dropdown-menu-right" : "dropdown-menu dropdown-menu-right custom-dropdown-menu-right"} >
                      {/* if not paid post and user account is free and if they have image or video than show that image in whatsapp */}
                      <CopyToClipboard
                        text={(post.is_paid_post == 0 && post.user.user_account_type_formatted == "Free" && post.postFiles.length > 0) ? process.env.REACT_APP_FRONT_URL + "/share/share.php?id=" + post.post_unique_id : window.location.origin + "/" + post.share_link}
                        onCopy={onCopy}
                      >
                        <Media as="li">
                          <Link to="#" className="dropdown-a">
                            {" "}
                            {t("copy_link_to_post")}{" "}
                          </Link>
                        </Media>
                      </CopyToClipboard>
                      <Media as="li" className="divider"></Media>

                      {localStorage.getItem("userId") != post.user_id ? (
                        <Media as="li">
                          <Link
                            to=""
                            onClick={(event) => handleReportPost(event, post)}
                            className="dropdown-a"
                          >
                            {t("report")}
                          </Link>
                        </Media>
                      ) : null}
                      {/* Report Post with reasons start */}
                      {/* <Media as="li">
                        <Link onClick={() => setReportMode(true)}>
                          {" "}
                          Report{" "}
                        </Link>
                      </Media> */}
                      {/* Report Post with reasons end */}

                      {localStorage.getItem("userId") != post.user_id ? (
                        <Media as="li">
                          <Link
                            to="#"
                            onClick={(event) => handleBlockUser(event, post)}
                            className="dropdown-a"
                          >
                            {" "}
                            {t("add_to_blocklist_para")}
                          </Link>
                        </Media>
                      ) : null}
                      {post.edit_btn_status == 1 ? (
                        <>
                          <Media as="li" className="divider"></Media>

                          <Media as="li">
                            <Link
                              to={'/edit-post/' + post.post_unique_id}
                              className="dropdown-a"
                            >
                              {t("edit_post")}
                            </Link>
                          </Media>
                        </>
                      ) : null}
                      {post.delete_btn_status == 1 ? (
                        <>
                          <Media as="li" className="divider"></Media>

                          <Media as="li">
                            <Link
                              to="#"
                              onClick={(event) => handleDeletePost(event, post)}
                              className="dropdown-a"
                            >
                              {t("delete_post")}
                            </Link>
                          </Media>
                        </>
                      ) : null}
                    </Dropdown.Menu>
                  </Dropdown>
                </span>
                {post.is_user_needs_pay === 1 ? (
                  post.payment_info.post_payment_type === "ppv" ? (
                    <span
                      className="post-time"
                      onClick={(event) =>
                        handlePPVPayment(event, post.is_user_needs_pay)
                      }
                    >
                      <span className="post-tip-lock">
                        {post.amount_formatted}{" "}
                      </span>
                      <Link
                        to="#"
                        onClick={(event) =>
                          handlePPVPayment(event, post.is_user_needs_pay)
                        }
                      >
                        <i className="fa fa-lock"></i>
                      </Link>
                    </span>
                  ) : (
                    <Link to="#">
                      <i className="fa fa-unlock text-success"></i>
                    </Link>
                  )
                ) : post.amount > 0 ? (
                  <span className="post-time">
                    <span className="post-tip-lock">
                      {post.amount_formatted}{" "}
                    </span>
                    <Link to="#">
                      <i className="fa fa-unlock text-success"></i>
                    </Link>
                  </span>
                ) : null}
              </div>
            </div>
          </div>

          <div className="post-content">
            {/* <p>{post.content != undefined ? post.content : ""}</p> */}
            <p
              dangerouslySetInnerHTML={{
                __html: post.content != undefined ? post.content : "",
              }}
            ></p>
            {/* {post && post?.hyperlink &&
              <a className="font-14" href={post.hyperlink}>{post.hyperlink}</a>} */}
            {post.postFiles
              ? post.postFiles.length > 0
                ? post.postFiles.map((postFile, index) =>
                  postFile.file_type === "image" ? (
                    <Link
                      to="#"
                      key={index}
                      onClick={(event) =>
                        post.payment_info.post_payment_type === "ppv" &&
                          post.payment_info.is_user_needs_pay === 1
                          ? handlePPVPayment(
                            event,
                            post.payment_info.is_user_needs_pay
                          )
                          : handleImagePreview(
                            event,
                            1,
                            post.payment_info.is_user_needs_pay
                          )
                      }
                    >
                      <div className="post-image" key={index}>
                        <div className="">
                          <div className="gallery js-gallery">
                            {post.payment_info.is_user_needs_pay == 1 ? (
                              <Image
                                src={
                                  api.serviceUrl() + "/" + postFile.post_file
                                }
                                className="post-view-image"
                              />
                            ) : (
                              <Image
                                src={
                                  api.serviceUrl() + "/" + postFile.post_file
                                }
                                className="post-view-image"
                                onClick={(event) =>
                                  handleImagePreview(event, 1)
                                }
                              />
                            )}
                          </div>
                          {post.payment_info.is_user_needs_pay === 1 &&
                            post.payment_info.post_payment_type === "ppv" ? (
                            <div className="gallery-top-btn-sec">
                              <Button
                                className="subscribe-post-btn-sec"
                                onClick={(event) =>
                                  handlePPVPayment(event, 1)
                                }
                              >
                                {post.payment_info.payment_text}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {post.payment_info.is_user_needs_pay === 1 &&
                            post.payment_info.post_payment_type ===
                            "subscription" ? (
                            <div
                              className="gallery-top-btn-sec"
                              onClick={props.scrollToTop}
                            >
                              <Button className="subscribe-post-btn-sec">
                                {post.payment_info.payment_text}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {modalStatus ? (
                          <Lightbox
                            mainSrc={
                              api.serviceUrl() + "/" + postFile.post_file
                            }
                            // nextSrc={images[(photoIndex + 1) % images.length]}
                            // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                            onCloseRequest={() => setModalStatus(0)}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Link>
                  ) : postFile.file_type === "video" ? (
                    <div className="post-image post-video" key={index}>
                      <div className="">
                        <div className="gallery js-gallery">
                          {post.payment_info.is_user_needs_pay == 1 ? (
                            <div className="gallery-img-sec">
                              <Image
                                src={
                                  postFile.preview_file
                                    ? api.serviceUrl() +
                                    "/" +
                                    postFile.preview_file
                                    : api.serviceUrl() +
                                    "/" +
                                    postFile.post_file
                                }
                                className="post-view-image"
                              />
                              <div className="gallery-play-icon"></div>
                            </div>
                          ) : (
                            <div style={{ position: "relative", maxWidth: "900px" }}>
                              <ReactPlayer
                                light={
                                  api.serviceUrl() + "/" + postFile.preview_file
                                }
                                url={playingAd ? adUrl : mainUrl}
                                controls={!playingAd}
                                width="100%"
                                height="100%"
                                className="post-video-size"
                                playsinline
                                playing={true}
                                onDuration={(d) => setDuration(d)}
                                onProgress={handleProgress}
                                onEnded={() => {
                                  if (playingAd) {
                                    setPlayingAd(false);
                                    // when advertisement end that time ad track
                                    saveAdTrack(post?.ad?.id, post.post_id, post.user_id)

                                  }
                                }}
                                config={{
                                  file: {
                                    attributes: { controlsList: "nodownload", preload: "auto" },
                                  },
                                }}
                                onStart={() => {
                                  setShowAd(true);
                                  if (playingAd) {
                                    // saveAdTrack(post?.ad?.id, post.post_id, post.user_id)
                                  } else {
                                    saveViewCount(post.post_id, post.user_id)
                                  }
                                }}
                              />
                              {/* Ad Label */}
                              {playingAd && showAd && (
                                <div style={styles.adBadge}>
                                  Advertisement
                                </div>
                              )}

                              {/* Skip UI */}
                              {playingAd && showAd && playedSeconds >= skipDelay && (
                                <div style={styles.skipBox}>
                                  {skipCountdown > 0 ? (
                                    <span style={styles.skipLabel}>Skip in {skipCountdown}</span>
                                  ) : (
                                    <button className="btn btn-secondary" style={styles.skipButton} onClick={() => setPlayingAd(false)}>
                                      Skip Ad
                                    </button>
                                  )}
                                </div>
                              )}

                              {/* Timer Row BELOW video */}
                              {playingAd && showAd &&
                                <div style={styles.timerRow}>
                                  <span>{format(playedSeconds)} / {format(duration)}</span>
                                </div>}
                            </div>
                          )}

                          {post.payment_info.is_user_needs_pay === 1 &&
                            post.payment_info.post_payment_type === "ppv" ? (
                            <div className="gallery-top-btn-sec">
                              <Button
                                className="subscribe-post-btn-sec"
                                onClick={(event) =>
                                  handlePPVPayment(event, 1)
                                }
                              >
                                {post.payment_info.payment_text}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {post.payment_info.is_user_needs_pay === 1 &&
                            post.payment_info.post_payment_type ===
                            "subscription" ? (
                            <div
                              className="gallery-top-btn-sec"
                              onClick={props.scrollToTop}
                            >
                              <Button className="subscribe-post-btn-sec">
                                {post.payment_info.payment_text}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                )
                : null
              : null}
          </div>
          {/* if rebel user than show  */}
          {post && post?.hyperlink && (
            <div style={{ paddingTop: "25px" }}>
              <HomePostUser hyperlink_user={post?.hyperlink_user} />
            </div>
          )}
          <div className="post-icons">
            <div className="alignleft d-flex align-items-center post-left-icons" style={{ gap: '20px' }}>
              <div className="d-flex align-items-center">
                <Link
                  to="#"
                  onClick={(event) => handleLike(event, isLiked ? "removed" : "added")}
                >
                  <Image
                    src={
                      window.location.origin +
                      (isLiked
                        ? "/assets/images/icons/heart-active.svg"
                        : "/assets/images/icons/heart.svg")
                    }
                    className="svg-clone"
                  />
                </Link>
                <span className="text-black font-weight-bold" style={{ fontSize: '15px' }}>{likeCount}</span>
              </div>

              <div className="d-flex align-items-center">
                <Link
                  to="#"
                  onClick={(event) => toggleCommentSection(event, post.post_id)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/comment.svg"
                    }
                    className="svg-clone"
                  />
                </Link>
                <span className="font-weight-bold" style={{ fontSize: '15px' }}>{localComments.length}</span>
              </div>

              {localStorage.getItem("userId") != post.user_id ? (
                <Button
                  type="button"
                  className="g-icon"
                  onClick={() => setSendTip(true)}
                >
                  <Image
                    src={
                      window.location.origin + "/assets/images/icons/tip.svg"
                    }
                    className="svg-clone"
                  />

                  <span className="post-tip">{t("send_tip")}</span>
                </Button>
              ) : null}
            </div>
            <div className="alignright">
              {localStorage.getItem("userId") == post.user_id && (<strong style={{ marginRight: "5px" }}>{totalViews} Views</strong>)}
              {bookmarkStatus !== "" ? (
                <>
                  <>
                    {bookmarkStatus === "added" ? (
                      <Link
                        to="#"
                        onClick={(event) =>
                          handleBookmark(event, post, "removed")
                        }
                      >
                        <Image
                          src={
                            window.location.origin +
                            "/assets/images/icons/bookmark-active.svg"
                          }
                          className="svg-clone"
                        />
                      </Link>
                    ) : null}
                  </>
                  <>
                    {bookmarkStatus === "removed" ? (
                      <Link
                        to="#"
                        onClick={(event) =>
                          handleBookmark(event, post, "added")
                        }
                      >
                        <Image
                          src={
                            window.location.origin +
                            "/assets/images/icons/bookmark.svg"
                          }
                          className="svg-clone"
                        />
                      </Link>
                    ) : null}
                  </>
                </>
              ) : post.is_user_bookmarked == 1 ? (
                <Link
                  to="#"
                  onClick={(event) => handleBookmark(event, post, "removed")}
                >
                  <Image
                    src={
                      window.location.origin +
                      "/assets/images/icons/bookmark-active.svg"
                    }
                    className="svg-clone"
                  />
                </Link>
              ) : (
                <Link
                  to="#"
                  onClick={(event) => handleBookmark(event, post, "added")}
                >
                  <Image
                    src={
                      window.location.origin +
                      "/assets/images/icons/bookmark.svg"
                    }
                    className="svg-clone"
                  />
                </Link>
              )}
            </div>
          </div>

          <div className="likes alignleft">
            {isVisible && commentInputData.post_id === post.post_id ? (
              <Link
                to="#"
                className="Show view-comments"
                onClick={closeCommentSection}
              >
                {t("close_comments")}
              </Link>
            ) : (
              <Link
                to="#"
                className="Show view-comments text-muted"
                onClick={(event) => showCommentSection(event, post.post_id)}
              >
                {t("view_comments")}
              </Link>
            )}
            {isVisible && commentInputData.post_id === post.post_id ? (
              <div id="target">
                {localComments.length > 0
                  ? localComments.map((comment, index) => (
                    <div className="row comment-row" key={index}>
                      <div className="alignleft d-flex">
                        <Link
                          className="title-container"
                          to={`/` + comment.user_unique_id}
                        >
                          <Image
                            src={
                              comment.user_picture
                                ? api.serviceUrl() +
                                "/" +
                                comment.user_picture
                                : "/assets/images/upload-profile-img.svg"
                            }
                            className="user-image img-responsive"
                          />
                        </Link>
                        <div className="user-name">
                          <span className="card-title">
                            <Link
                              className="title-container-1"
                              to={`/` + comment.user_unique_id}
                            >
                              {comment.user_displayname}{" "}
                            </Link>
                            <span className="comment-message">
                              {comment.comment}
                            </span>
                          </span>
                          <div className="comment-info-sec">
                            <ul className="list-unstyled comment-info-link">
                              <Media as="li">
                                <p style={{ fontSize: 13 }}>{comment.created}</p>
                              </Media>
                              {/* <Media as="li">
                                  <p>1 Like</p>
                              </Media>
                              <Media as="li">
                                  <p>Reply</p>
                              </Media> */}
                            </ul>
                          </div>
                        </div>
                        {/* <div className="whishlist-heart-icon">
                            <i className="far fa-heart"></i>
                          </div> */}
                      </div>
                    </div>
                  ))
                  : ""}

                <div className="comment-box">
                  <div className="comment-box-form">
                    <Form
                      className="form-inline"
                      action=""
                      onSubmit={handleCommentSubmit}
                    >
                      <div className="user-picture">
                        <Link className="title-container-1" to="#">
                          <Image
                            src={
                              localStorage.getItem("user_picture") != "null"
                                ? api.serviceUrl() +
                                "/" +
                                localStorage.getItem("user_picture")
                                : "/assets/images/upload-profile-img.svg"
                            }
                            className="user-image img-responsive"
                          />
                        </Link>
                      </div>
                      <div className="text-box">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          type="text"
                          className="form-control"
                          id="comment"
                          placeholder="Add a comment"
                          name="comment"
                          value={commentInputData.comment}
                          onChange={(event) =>
                            setCommentInputData({
                              ...commentInputData,
                              comment: event.currentTarget.value,
                            })
                          }
                        />
                      </div>
                      <Button
                        type="submit"
                        className="custom-btn"
                        onClick={handleCommentSubmit}
                      >
                        <i className="fas fa-paper-plane"></i>
                      </Button>
                    </Form>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <SendTipModal
            sendTip={sendTip}
            closeSendTipModal={closeSendTipModal}
            username={post.username}
            userPicture={post.user_picture}
            name={post.user_displayname}
            post_id={post.post_id}
            user_id={post.user_id}
          />
          <PPVPaymentModal
            PPVPayment={PPVPayment}
            closePPVPaymentModal={closePPVPaymentModal}
            post={post}
            username={post.username}
            userPicture={post.user_picture}
            name={post.user_displayname}
            post_id={post.post_id}
            user_id={post.user_id}
            amount={post.amount}
          />
          <ReportModeModal
            reportMode={reportMode}
            closeReportModeModal={closeReportModeModal}
          />
        </div >
      ) : (
        ""
      )}
    </>
  );
};

const styles = {
  adBadge: {
    position: "absolute",
    top: 15,
    left: 15,
    background: "#6c757d",
    color: "white",
    padding: "5px 10px",
    fontSize: 12
  },
  skipBox: {
    position: "absolute",
    bottom: 25,
    right: 20,
  },
  skipButton: {
    padding: "7px 10px",
    fontSize: 12
  },
  skipLabel: {
    background: "#6c757d",
    color: "white",
    padding: "7px 10px",
    fontSize: 12
  },
  timerRow: {
    position: "absolute",
    bottom: 20,
    left: 20,
    background: "#6c757d",
    color: "white",
    padding: "5px 10px",
  }
};

const mapStateToPros = (state) => ({
  comments: state.comment.comments,
  saveComment: state.comment.saveComment,
  delComment: state.comment.delComment,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(translate(PostDisplayCard));
